<div class="flex items-center gap-2">
  <ui-dropdown
    (singleSelectedItemChange)="onConditionSelected($event)"
    [buttonFullWidth]="true"
    [buttonJustifyContent]="'between'"
    [buttonVariant]="'tertiary'"
    [enableSearch]="false"
    [items]="conditionItems"
    [menuItemWidth]="'adjustToParent'"
    [multiple]="false"
    [singleSelectedItem]="selectedConditionItem"
    class="min-w-0 flex-1"
  ></ui-dropdown>

  <ui-button
    (clicked)="remove.emit()"
    [attr.aria-label]="'review-workflow.Condition_remove' | translate"
    [label]="''"
    icon="Trash2"
    variant="destructive"
  ></ui-button>
</div>
